import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const INITIAL_STATE = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  fcmState: {
    isLoading: false,
    error: null,
  },
  apiStatus: {
    statusCode: null,
    statusText: null,
    data: false,
  },
  apiStatusDid: {
    statusCode: null,
    statusText: null,
    data: false,
  },
};

export const fcmSlice = createSlice({
  name: "fcm",
  initialState: INITIAL_STATE,
  reducers: {
    updateFcmToken: (state) => {
      state.fcmState.isLoading = true;
    },
    updateFcmTokenSuccess: (state, action: PayloadAction<any>) => ({
      ...state,
      fcmState: {
        ...state.fcmState,
        error: null,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
        data: action.payload?.data,
      },
    }),
    updateFcmTokenFailure: (state, action: PayloadAction<any>) => ({
      ...state,
      fcmState: {
        ...state.fcmState,
        error: action.payload?.message,
        isLoading: false,
      },
      apiStatus: {
        ...state.apiStatus,
        statusCode: action.payload?.statusCode,
        statusText: action.payload?.statusText,
      },
    }),
  },
});

export const {
  updateFcmToken,
  updateFcmTokenFailure,
  updateFcmTokenSuccess,
} = fcmSlice.actions;
export const fcmReducer = fcmSlice.reducer;
